import { ISession } from "@/interfaces"
import { defineStore } from "pinia"
import { computed, ref } from "vue"

const STORAGE_KEY = "SESSION_STORAGE"
const STORE_KEY = "SESSION_STORE"

const getFromLocalStorage = (): ISession | null => {
    const item = localStorage.getItem(STORAGE_KEY)
    if (!item) return null
    return JSON.parse(item) as ISession
}
export const useSessionStore = defineStore(STORE_KEY, () => {
    const session = ref<ISession | null>(getFromLocalStorage())
    const currentBalance = computed(() => {
        if (session.value && session.value.balance) {
            return session.value.balance
        }
        return 0
    })

    function createSession(params: ISession) {
        session.value = params
        updateLocalStorage()
    }

    function clearSession() {
        session.value = null
        clearLocalStorage()
    }

    function updateSession(params: Partial<ISession>) {
        if (!session.value) return
        session.value = { ...session.value, ...params }
        updateLocalStorage()
    }
    function updateLocalStorage() {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(session.value))
    }
    function clearLocalStorage() {
        localStorage.removeItem(STORAGE_KEY)
    }

    return { session, createSession, updateSession, clearSession, currentBalance }
})